import { CONFIG, clientIdGoogle } from 'app/config/config';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import useDrivePicker from 'react-google-drive-picker';

function GoogleDrivePicker({ onChangeGooglePicker, onAuthFailed, ...props }) {
  const [openPicker, authResponse] = useDrivePicker();
  const [token, setToken] = useState(authResponse && authResponse.access_token);
  const refToken = useRef(token);

  useEffect(() => {
    if (authResponse !== undefined) {
      setToken(authResponse.access_token);
      refToken.current = authResponse.access_token;
    }
  }, [authResponse]);

  const handleOpenPicker = () => {
    openPicker({
      clientId: clientIdGoogle[window.location.origin],
      developerKey: CONFIG.googleKeys?.DEVELOPER_KEY,
      customScopes: ['https://www.googleapis.com/auth/drive.file'],
      viewId: 'DOCS',
      showUploadView: false,
      showUploadFolders: false,
      supportDrives: true,
      multiselect: false,
      token: token,
      setOrigin: window.location.origin,
      callbackFunction: (data) => {
        if (data.action === 'cancel') {
          onAuthFailed();
        }
        onChangeGooglePicker(data, refToken.current);
      },
    });
  };

  return (
    <div className="google-picker" onClick={() => handleOpenPicker()}>
      {props.children ? props.children : <button>Open google picker</button>}
    </div>
  );
}

GoogleDrivePicker.defaultProps = {
  onChangeGooglePicker: function () {},
  onAuthFailed: function () {},
};

GoogleDrivePicker.propTypes = {
  onChangeGooglePicker: PropTypes.func,
  onAuthFailed: PropTypes.func,
};

export default GoogleDrivePicker;
